import classNames from "classnames";
import React from "react";
import styles from "./Project.module.scss";

export default function ProjectSlide({index, preview,setSlide,slide}) {
  return (
    <div className={classNames(styles.project__slide, {
      [styles.project__slide_active]: index===slide
    })} onClick={()=> setSlide(index)}>
      <div className={styles.project__slidePreview}>
        <img src={preview} alt={'Превью выпуска'} loading="lazy" fetchpriority={"auto"}/>
      </div>
      <div className={styles.project__slideName}>{`Выпуск ${index + 1}`}</div>
    </div>
  )
}
